import React from 'react';
import { Navigation } from '../components/Navigation';
import { WarningSignsSection } from '../components/WarningSignsSection';
import { Footer } from '../components/Footer';

const WarningSignsPage = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      <div className="pt-20">
        <WarningSignsSection />
      </div>
      <Footer />
    </div>
  );
};

export default WarningSignsPage;
